export const BREAKPOINT_SM = 600;
export const BREAKPOINT_MD = 900;
export const BREAKPOINT_LG = 1100;
export const BREAKPOINT_XL = 1400;


// WEBPACK FOOTER //
// ./src/constants/breakpoints.js